export default __webpack_public_path__ + "static/pic-3-b037ad2b226b49712caae1b9f358bf48.png";